// extracted by mini-css-extract-plugin
export var divider = "_u8-0";
export var systemMessage = "_u8-1";